import React from 'react';
import {observer} from "mobx-react";
import {SeeAllFooterWidget} from "../../../core/components/see-all-footer/see-all-footer";
import {NAVIGATION_TABS} from "../../../modules/navigation-tabs-module/navigation-tabs-module.consts";

export const PropositionBetsWidgetSeeAll = observer(({controller, onSeeAllClick}) => {
  const {state, device, terms} = controller;
  const {shouldRenderPreview, isGameRoute} = state;
  const {isRtl} = device;
  const {WEB_COMPETITION_ODDS_PREVIEW_SEE_ALL} = terms;

  const seeAllFooterProps = {
    isRtl,
    controller,
    buttonLabel: WEB_COMPETITION_ODDS_PREVIEW_SEE_ALL,
    routeProps: {tabIndex: NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.propositionBets},
    onClick: () => {
      onSeeAllClick && onSeeAllClick(NAVIGATION_TABS.TAB.INDEX.GAME_CENTER.propositionBets);

      return isGameRoute;
    }
  }

  return shouldRenderPreview ? <SeeAllFooterWidget {...seeAllFooterProps}/> : null
});
